import React, { FC } from 'react';
import clsx from 'clsx';
import { Box, CircularProgress } from '@material-ui/core';

import '../progress.scss';
import useDataGridProgressContext from '../DataGridProgress/context/DataGridProgressContext';

const DataGridProgress: FC = () => {
  const { visibility } = useDataGridProgressContext();
  const classes = clsx({
    'Box-progress': true,
    'dataGrid': true,
    'show': visibility,
    'hide': !visibility,
  });

  return (
    <Box className={classes}>
      <CircularProgress className="CircularProgress-spinner" />
    </Box>
  );
};

export default DataGridProgress;
